import BecomeApiProviderTemplate from "./BecomApiProviderTemplate";

const BecomeAPIProvider = () => {
  return (
    <>
      <BecomeApiProviderTemplate>

        <div className="p-10-40">
          <h1 className="patua-one-regular fs-40">Become an API Producer</h1>
            <p>If you’re a CDC Developer or Product Team and would like to add your API to the Digital Gateway, you’ll need to submit an API Registration Form. Select the button below to get started. </p>
          <h2 className="custom-h3">Submit a Tech Questionnaire</h2>
          <div>
            <a className='usa-button' href='https://servicedesk.cdc.gov/esc?id=sc_cat_item&table=sc_cat_item&sys_id=6c00be721be286d06aa6ece2604bcb33' target="_blank" rel="noopener noreferrer">
              Get Started
            </a>
          </div>
          <div className="custom-container-bap">
              <h2 className="custom-h3">Visit the Digital Gateway Docs Site</h2>
              <p>For more details around our platform, visit our documentation portal to learn about onboarding different APIs, formatting guidelines, training tutorials, security policies and more!</p>
              <div>
                <a className='usa-button usa-button--outline' href='https://docs.cdc.gov/docs/dgw' target="_blank" rel="noopener noreferrer">
                  Go to Docs Site
                </a>
              </div>
          </div>
        </div>
      </BecomeApiProviderTemplate>
    </>
  )
}

export default BecomeAPIProvider;
